module.exports = __webpack_public_path__ + "img/pd-img-face6.7d4acd68.png";